module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.listFilters), function(entry) {
    return _c('div', {
      staticClass: "list-filter"
    }, [_c('p', {
      staticClass: "list-filter-title"
    }, [_vm._v(_vm._s(entry.name))]), _vm._v(" "), _c('ul', {
      staticClass: "list-filter-list"
    }, _vm._l((entry.options), function(option) {
      return _c('li', {
        staticClass: "list-filter-item",
        class: {
          'list-filter-item--active': _vm.activeOption(entry, option)
        },
        on: {
          "click": function($event) {
            return _vm.setFilter(entry, option)
          }
        }
      }, [(option.icon) ? _c('i', {
        staticClass: "list-filter-icon",
        class: option.icon
      }) : _vm._e(), _vm._v("\n                " + _vm._s(option.label) + "\n            ")])
    }), 0)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f3838c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListFilterComponent.vue
// module id = 764
// module chunks = 0